document.addEventListener('DOMContentLoaded', function () {
  /**
   * @param {int} month
   * @returns {string}
   */
  function getMonthName(month) {
    const lng = document.documentElement.lang;
    switch (lng) {
      case 'tc':
      case 'sc':
        const months = {
          jan: '一月',
          feb: '二月',
          mar: '三月',
          apr: '四月',
          may: '五月',
          jun: '六月',
          jul: '七月',
          aug: '八月',
          sep: '九月',
          oct: '十月',
          nov: '十一月',
          dec: '十二月'
        };
        return months[String(month).toLowerCase()];
      default:
        return month;
    }
  }

  /**
   * @param {string} day
   * @returns {string}
   */
  function getDayName(day) {
    const lng = document.documentElement.lang;
    switch (lng) {
      case 'tc':
      case 'sc':
        const ds = {
          sun: '日',
          mon: '一',
          tue: '二',
          wed: '三',
          thu: '四',
          fri: '五',
          sat: '六'
        };
        return ds[String(day).toLowerCase()];
      default:
        return day;
    }
  }

  // ? legacy version
  $('.horizontal-calendar-date-selector').on('initial', function () {
    var $dateSelector = $(this),
      selectedDate = moment($dateSelector.find('input[name=date]').val());
    $(this).trigger('render', [selectedDate]);
    // add scroll listener to .date-holders
    // when scroll left not at 0, add class `can-scroll-left`
    // when scroll right not at max, add class `can-scroll
    $('.date-container .date-holders', $dateSelector).on('scroll', function (e) {
      var $dateHolders = $(this),
        $dateContainer = $dateHolders.parents('.date-container'),
        scrollLeft = $dateHolders.scrollLeft(),
        scrollWidth = $dateHolders.prop('scrollWidth'),
        clientWidth = $dateHolders.prop('clientWidth');
      $dateContainer[scrollLeft > 0 ? 'addClass' : 'removeClass']('can-scroll-left');
      $dateContainer[scrollLeft + clientWidth < scrollWidth ? 'addClass' : 'removeClass']('can-scroll-right');
    });
  }).on('render', function (e, momentSelectDate) {
    var $dateSelector = $(this),
      $inputSelectedDate = $dateSelector.find('input[name=date]'),
      $mySelector = $('.month-year-selector', $dateSelector),
      $dateHolder = $('.date-container .date-holders', $dateSelector),
      today = moment($dateSelector.attr('data-today'));
    $inputSelectedDate.val(momentSelectDate.format('YYYY-MM-DD'));
    $('.current-month', $mySelector).text(getMonthName(momentSelectDate.format('MMM')));
    $('.current-year', $mySelector).text(momentSelectDate.format('YYYY'));
    $dateHolder.empty();
    for (var i = 1; i <= parseInt(momentSelectDate.clone().endOf('month').format('DD')); i++) {
      var dateMoment = momentSelectDate.clone().date(i),
        $button = $('<button />', {
          class: `${dateMoment.isSame(today, 'day') ? 'today' : ''} ${dateMoment.isSame(momentSelectDate, 'day') ? 'selected' : ''}`,
          'data-event': 'select-date',
          'data-date': dateMoment.format('YYYY-MM-DD')
        }),
        $label = $('<label />', {
          text: dateMoment.format('DD')
        }),
        $span = $('<span />', {
          text: getDayName(dateMoment.format('ddd'))
        });
      $button.append($label).append($span);
      $dateHolder.append($button);
    }
    $dateSelector.trigger('middle-selected');
  }).on('click', 'button[data-event=prev-month], button[data-event=next-month]', function (e) {
    e.preventDefault();
    var $btn = $(this),
      $dateSelector = $btn.parents('.horizontal-calendar-date-selector'),
      $inputSelectedDate = $dateSelector.find('input[name=date]'),
      currentMY = moment($inputSelectedDate.val());
    var newSelectedDate = currentMY.clone().add($btn.attr('data-event') == 'prev-month' ? -1 : 1, 'month');
    $dateSelector.trigger('render', [newSelectedDate]);
  }).on('click', 'button[data-event=select-date]', function (e) {
    e.preventDefault();
    var $btn = $(this),
      $dateSelector = $btn.parents('.horizontal-calendar-date-selector'),
      $dateContainer = $('.date-container', $dateSelector);
    $dateContainer.find('.selected').removeClass('selected');
    $btn.addClass('selected');
    $dateSelector.find('input[name=date]').val($btn.attr('data-date'));
    $dateSelector.trigger('middle-selected');
    $btn.parents('form').trigger('submit');
  }).on('middle-selected', function () {
    var $dateSelector = $(this),
      $dateContainer = $('.date-container', $dateSelector),
      $dateHolders = $('.date-holders', $dateContainer),
      $btn = $dateHolders.find('button.selected');

    // scroll button to middle of container
    var btnIndex = $btn.parent().children('button').index($btn),
      btnWidth = $btn.outerWidth() + parseInt($btn.css('margin-right')),
      btnLeft = btnIndex * btnWidth;
    $dateHolders.scrollLeft(btnLeft - $dateHolders.width() / 2 + btnWidth / 2);
  }).trigger('initial');
  $('.expend-search-keyword').on('keyup', 'input[name]', function (e) {
    var $input = $(this);
    $input.parents('.expend-search-keyword')[$input.val().length > 0 ? 'addClass' : 'removeClass']('has-keyword');
  })
  // add press event to search input
  .on('keypress', 'input[name=keyword]', function (e) {
    if (e.key == 'Enter' || e.code == 'Enter') {
      e.preventDefault();
      var url = new URL(window.location.href);
      url.searchParams.set('keyword', $(this).val());
      history.pushState({}, '', url);
      $(this).parents('form').trigger('submit');
    }
  });
  $('.notice-strip').on('initial', function () {
    const $noticeSwiper = $('.swiper-container', this),
      $pagination = $('.swiper-pagination', this);
    new Swiper($noticeSwiper.get(0), {
      modules: window.swiperModule,
      autoplay: {
        delay: 8000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
        stopOnLastSlide: true
      },
      autoHeight: true,
      pagination: {
        el: $pagination.get(0),
        type: 'bullets',
        clickable: true
      }
    });
  }).on('click', '.notice-close i', function (e) {
    e.preventDefault();
    $(this).parents('.notice-strip').remove();
  }).trigger('initial');
  $('body').on('mouseenter', '.programme-image-container .images img', function (e) {
    var $activeImage = $(this),
      $imgContainer = $activeImage.parents('.programme-image-container'),
      $imageSet = $('.images', $imgContainer);
    $imageSet.attr('data-active-index', $activeImage.index() + 1);
    $imgContainer.trigger('change-index', [$activeImage.index()]);
  }).on('change-index', '.programme-image-container', function (e, index) {
    var $imgContainer = $(this),
      $pagination = $('.pagination', $imgContainer),
      $imageSet = $('.images', $imgContainer);
    $('span', $pagination).removeClass('active');
    $('span', $pagination).eq(index).addClass('active');
    $('img', $imageSet).removeClass('active');
    $('img', $imageSet).eq(index).addClass('active');
    $imgContainer.trigger('index-changed', [index]);
  });
  $('.programme-image-container').on('initial', function () {
    var $imgContainer = $(this),
      $imageSet = $('.images', $imgContainer);
    // chage $pagination>span active class by listener to the current index of image in $imageSet
    $imageSet.on('scroll', function (e) {
      var $images = $(this),
        imgWidth = $images.find('img').outerWidth(),
        imgIndex = Math.round($images.scrollLeft() / imgWidth);
      $imgContainer.trigger('change-index', [imgIndex]);
    });
  }).trigger('initial');
  $('.masonry').on('initial', function () {
    // Resize all the grid items on the load and resize events
    var $masonry = $(this),
      $items = $('.masonry-item', $masonry);
    $items.each(function () {
      var $img = $('img', this);
      $img.one('load', function () {
        $img.removeAttr('data-src');
        $img.closest('.masonry-item').trigger('resize-item');
      });
      $img.attr('src', $img.attr('data-src'));
    });
  }).on('resize-all', function () {
    console.log('resize-all');
    // Get all item class objects in one list
    // Loop through the above list and execute the spanning function to each list-item
    $(this).find('.masonry-item').each(function () {
      $(this).trigger('resize-item');
    });
  }).on('resize-item', '.masonry-item', function () {
    var $item = $(this);
    if (window.innerWidth < 768) {
      return $item.removeAttr('style').find('.masonry-content').removeAttr('style');
    }
    var $masonry = $item.parent('.masonry'),
      rowGap = parseInt($masonry.css('grid-row-gap')),
      rowHeight = parseInt($masonry.css('grid-auto-rows'));
    var rowSpan = Math.ceil(($('img', $item).height() + rowGap) / (rowHeight + rowGap));
    $item.css('grid-row-end', 'span ' + rowSpan);
  }).trigger('initial');
  if ($('.masonry').length > 0) {
    $(window).on('load resize', function () {
      $('.masonry').trigger('resize-all');
    });
  }
  $('.load-more-content.ajax-load').on('click', 'a', function (e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.prop('loading')) return;

    // get query params from current url
    var currentUrl = new URL(location),
      loadUrl = new URL($btn.attr('href')),
      loadingText = $btn.attr('data-loading-text'),
      appendContainer = $btn.attr('data-append-container'),
      currentPage = parseInt($btn.prop('currentPage') ?? 1);
    loadUrl.search = currentUrl.search;
    loadUrl.searchParams.set('page', currentPage + 1);
    $.ajax({
      url: loadUrl.toString(),
      type: 'GET',
      dataType: 'html',
      beforeSend: function () {
        $btn.prop('loading', true);
        $btn.prop('defaultText', $btn.text());
        $btn.addClass('loading').html('<div class="icon-animated one-ball-bouncing me-1"><span></span></div>' + loadingText);
      },
      success: function (html) {
        $btn.prop('loading', false);
        $btn.removeClass('loading').text($btn.prop('defaultText'));

        // if element in result, that in appendContainer
        $(appendContainer).append(html);
        // Update current page number
        $btn.prop('currentPage', currentPage + 1);
        // If no more content, hide the button
        if (html.length == 0) $btn.hide();
      }
    });
  });
  var getResponsiveMonths = function () {
    var gridSize = $.gridSize();
    if ([null, 'xs', 'sm'].includes(gridSize)) return 1;
    return 2;
  };
  var resizeEventForCalendar = function () {
    console.log('resizeEventForCalendar');
    var fp = $('#filter-modal #filter-date-picker').get(0)._flatpickr;
    if (fp) {
      var monthCnt = getResponsiveMonths();
      fp.set('showMonths', monthCnt);
      fp.calendarContainer.setAttribute('data-months', monthCnt);
    }
  };
  var formatDateToYYYYMMDD = function (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  $('#filter-modal').on('shown.bs.modal', function () {
    $(this).trigger('initial-calendar');
    window.addEventListener('resize', resizeEventForCalendar);
  }).on('hidden.bs.modal', function () {
    $(this).trigger('destroy-calendar');
    window.removeEventListener('resize', resizeEventForCalendar);
  }).on('shown.bs.dropdown', '#filter-date', function () {
    $(this).parents('#filter-modal').trigger('initial-calendar');
  }).on('hidden.bs.dropdown', '#filter-date', function () {
    $(this).parents('#filter-modal').trigger('destroy-calendar');
  }).on('initial-calendar', function () {
    var $modal = $(this),
      $inputDatePicker = $('#filter-date-picker', $modal),
      monthCnt = getResponsiveMonths();
    $inputDatePicker.flatpickr({
      inline: true,
      showMonths: monthCnt,
      monthSelectorType: "static",
      mode: "range",
      dateFormat: "Y-m-d",
      nextArrow: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.2652 11.7348C18.4116 11.8813 18.4116 12.1187 18.2652 12.2652L15.8787 14.6517C15.7322 14.7981 15.4948 14.7981 15.3483 14.6517C15.2019 14.5052 15.2019 14.2678 15.3483 14.1213L17.4697 12L15.3483 9.87868C15.2019 9.73223 15.2019 9.4948 15.3483 9.34835C15.4948 9.2019 15.7322 9.2019 15.8787 9.34835L18.2652 11.7348ZM6 11.625L18 11.625V12.375L6 12.375V11.625Z"/><circle cx="12" cy="12" r="11.625" transform="matrix(-1 0 0 1 24 0)" stroke-width="0.75"/></svg>',
      prevArrow: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.73483 11.7348C5.58839 11.8813 5.58839 12.1187 5.73483 12.2652L8.12132 14.6517C8.26777 14.7981 8.5052 14.7981 8.65165 14.6517C8.7981 14.5052 8.7981 14.2678 8.65165 14.1213L6.53033 12L8.65165 9.87868C8.7981 9.73223 8.7981 9.4948 8.65165 9.34835C8.5052 9.2019 8.26777 9.2019 8.12132 9.34835L5.73483 11.7348ZM18 11.625L6 11.625V12.375L18 12.375V11.625Z"/><circle cx="12" cy="12" r="11.625" stroke-width="0.75"/></svg>',
      onChange: function (selectedDates, dateStr, instance) {
        if (selectedDates.length > 0) {
          $('input[type=radio][name=date]', $modal).prop('checked', false);
          $('input[value=custom_date]', $modal).prop('checked', true);
          if (selectedDates.length == 2) {
            var dateString = formatDateToYYYYMMDD(selectedDates[0]);
            if (selectedDates[0].getTime() != selectedDates[1].getTime()) dateString += ' - ' + formatDateToYYYYMMDD(selectedDates[1]);

            // update date in search-key-list
            var $selectedKeyContainer = $modal.siblings('.selected-key-container'),
              $searchKeyList = $('.search-key-list', $selectedKeyContainer);
            var $dateTag = $('button[data-type=date]', $searchKeyList).parents('.search-key-item');
            if ($dateTag.length == 0) {
              // Add tag
              $dateTag = $($('template#search-key-item').html());
              $('button', $dateTag).attr({
                'data-type': 'date'
              });
              $('span', $dateTag).not('.parent').text(dateString);
              $('span.parent', $dateTag).text($selectedKeyContainer.attr('data-date-label'));
              $searchKeyList.append($dateTag);
            } else {
              // Update tag
              $('span', $dateTag).not('.parent').text(dateString);
            }
            $selectedKeyContainer.trigger('refresh');
            $('#filter-date').dropdown('hide');
            $modal.trigger('filter-change');
          }
        } else {
          $('input[value=custom_date]', $modal).prop('checked', false);
        }
      }
    });
    $inputDatePicker.get(0)._flatpickr.calendarContainer.setAttribute('data-months', monthCnt);
  }).on('click', '.dropdown-date-picker', function (e) {
    e.stopPropagation();
  }).on('destroy-calendar', function () {
    var $modal = $(this),
      $inputDatePicker = $('#filter-date-picker', $modal);
    $inputDatePicker.prop('calendar')?.destroy();
  }).on('click', '.dropdown-item', function (e) {
    e.stopPropagation();
  }).on('click', 'button[data-event=apply-filter]', function (e) {
    e.preventDefault();
    $(this).parents('form').trigger('submit');
  }).on('click', 'button[data-event=clear-all-filter]', function (e) {
    e.preventDefault();
    var $modal = $(this).parents('#filter-modal');
    $('input[type=checkbox]', $modal).prop('checked', false);
    $('input[type=radio]', $modal).prop('checked', false);
    $('input[name=custom_date]', $modal).val('');
    $('.selected-key-container').trigger('clear');
    $(this).parents('form').trigger('submit');
  }).on('filter-change', function () {
    console.log('Filter Changed', $(this).parents('form'));
    if (!$.isMobileView()) $(this).parents('form').trigger('submit');
  })
  // tag filter
  .on('click', '[data-event=clear-part-tags]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $dropdown = $(this).parents('.dropdown');
    $('input[type=checkbox]', $dropdown).prop('checked', false);
    $dropdown.parents('.modal').trigger('filter-change');
  }).on('change', 'input[name=tags]', function () {
    var $tag = $(this);
    $tag.parents('.modal').trigger('filter-change');

    // Handle search keywords column,
    var $filterContainer = $tag.parents('.filter-container'),
      $selectedKeyContainer = $('.selected-key-container', $filterContainer),
      $searchKeyList = $('.search-key-list', $selectedKeyContainer);
    if ($tag.prop('checked')) {
      // add tag to selected key container
      var $newTag = $($('template#search-key-item').html());
      $('button', $newTag).attr({
        'data-type': 'tags',
        'data-tag-code': $tag.val()
      });
      $('span', $newTag).not('.parent').text($tag.attr('data-name'));
      if ($tag.attr('data-parent-name')) {
        $('span.parent', $newTag).text($tag.attr('data-parent-name'));
      }
      $searchKeyList.append($newTag);
    } else {
      // Remove tag from selected key container
      $('button[data-tag-code="' + $tag.val() + '"]', $searchKeyList).parents('.search-key-item').remove();
    }
    $selectedKeyContainer.trigger('refresh');
  })
  // date filter
  .on('change', 'input[type=radio][name=date]', function () {
    var $radio = $(this),
      $modal = $radio.parents('#filter-modal'),
      $inputDatePicker = $('#filter-date-picker', $modal);
    $('input[value=custom_date]', $modal).prop('checked', false);
    $inputDatePicker.prop('calendar')?.clear();
    $('#filter-date').dropdown('hide');
    $modal.trigger('filter-change');

    // Handle search keywords column
    var $selectedKeyContainer = $modal.siblings('.selected-key-container'),
      $searchKeyList = $('.search-key-list', $selectedKeyContainer);
    var $dateTag = $('button[data-type=date]', $searchKeyList).parents('.search-key-item');
    if ($dateTag.length == 0) {
      // Add tag
      $dateTag = $($('template#search-key-item').html());
      $('button', $dateTag).attr({
        'data-type': 'date'
      });
      $('span.parent', $dateTag).text($selectedKeyContainer.attr('data-date-label'));
      $('span', $dateTag).not('.parent').text($radio.val());
      $searchKeyList.append($dateTag);
    } else {
      // Update tag
      $('span', $dateTag).not('.parent').text($radio.val());
    }
    $selectedKeyContainer.trigger('refresh');
  }).trigger('initial');
  $('.selected-key-container').on('clear', function () {
    var $selectedKeyContainer = $(this),
      $searchKeyList = $('.search-key-list', $selectedKeyContainer);
    $searchKeyList.empty();
    $selectedKeyContainer.trigger('refresh');
  }).on('refresh', function () {
    var $searchKeyList = $('.search-key-list', this);
    if ($('.search-key-item', $searchKeyList).length > 0) {
      $searchKeyList.parents('.selected-key-container').removeClass('d-none');
    } else {
      $searchKeyList.parents('.selected-key-container').addClass('d-none');
    }
  }).on('click', '[data-event=remove-keyword]', function (e) {
    e.preventDefault();
    var $removeBtn = $(this),
      $keyItem = $removeBtn.parents('.search-key-item'),
      $filterModal = $('#filter-modal');
    switch ($removeBtn.attr('data-type')) {
      case 'tags':
        $('input[name=tags][value="' + $removeBtn.attr('data-tag-code') + '"]', $filterModal).prop('checked', false).trigger('change');
        break;
      case 'date':
        $('input[name=custom_date]', $filterModal).val('');
        $('input[type=radio][name=date]', $filterModal).prop('checked', false);
        break;
    }
    $keyItem.remove();
    $('.selected-key-container').trigger('refresh');
    $filterModal.trigger('filter-change');
  });
  $('.animated-balls').on('swipe-ball', 'span', function (e) {
    var $currentBall = $(this),
      $nextBall = $currentBall.next(),
      ballSize = parseInt($currentBall.css('width'));
    if ($nextBall.length == 0) return;
    $nextBall.css({
      transition: 'top .5s',
      top: `-${ballSize * 2}px`
    });
    setTimeout(function () {
      $currentBall.css({
        transition: 'left .5s',
        left: `${ballSize * 2}px`
      });
    }, 500);
    setTimeout(function () {
      $nextBall.css({
        transition: 'top .5s, left .5s',
        left: `-${ballSize * 2}px`,
        top: '0'
      });
    }, 1000);
    setTimeout(function () {
      $nextBall.removeAttr('style');
      $currentBall.removeAttr('style');
    }, 1500);
  }).on('start', function (e, interval = 2000) {
    var $balls = $(this).find('span'),
      ballCnt = $balls.length,
      currBallIndex = 0;
    // swipe ball every 2s by sequence
    setInterval(function () {
      $balls.eq(currBallIndex).trigger('swipe-ball');
      currBallIndex++;
      if (currBallIndex >= ballCnt) currBallIndex = 0;
    }, interval);
  }).trigger('start');
  $('.share-url').on('click', '[data-share-method]', function (e) {
    e.preventDefault();
    console.log('click');
    var $btn = $(this),
      shareMethod = $btn.attr('data-share-method'),
      title = document.getElementsByTagName("title")[0].innerHTML,
      url = location.href,
      shareUrl = null;
    switch (shareMethod) {
      case 'whatsapp':
        shareUrl = new URL('https://api.whatsapp.com/send');
        shareUrl.search = jQuery.param({
          text: title + ' ' + url
        });
        break;
      case 'facebook':
        shareUrl = new URL('https://www.facebook.com/dialog/share');
        shareUrl.search = jQuery.param({
          app_id: $('html meta[property="fb:app_id"]').attr('content'),
          display: 'page',
          href: url
        });
        break;
      case 'messenger':
        shareUrl = new URL('https://www.facebook.com/dialog/send');
        shareUrl.search = jQuery.param({
          app_id: $('html meta[property="fb:app_id"]').attr('content'),
          display: 'page',
          redirect_uri: url,
          link: url
        });
        break;
      case 'linkedin':
        // https://learn.microsoft.com/en-us/linkedin/consumer/integrations/self-serve/plugins/share-plugin
        shareUrl = new URL('https://www.linkedin.com/sharing/share-offsite');
        shareUrl.search = jQuery.param({
          url: url
        });
        break;
      case 'twitter':
        shareUrl = new URL('https://twitter.com/intent/tweet');
        shareUrl.search = jQuery.param({
          text: title,
          url: url
        });
        break;
      case 'email':
        shareUrl = new URL('mailto:');
        shareUrl.search = jQuery.param({
          subject: title,
          body: url
        });
        break;
    }
    if (shareUrl == null) {
      console.error('Share type [' + type + '] not supported.');
      return;
    }
    window.open(shareUrl.toString(), '_blank', 'noopener');
  });
  $('#image-player-modal').on('render', function (e, figureData) {
    var $modal = $(this),
      $figureContainer = $('.figures-container', $modal);

    // Create swiper dom elements, with pagination bullet
    var $swiperContainer = $('<div />', {
        class: 'swiper-container'
      }),
      $swiperWrapper = $('<div />', {
        class: 'swiper-wrapper'
      }),
      $swiperPagination = $('<div />', {
        class: 'swiper-pagination'
      });

    // append figureData to $figureContainer
    figureData.forEach(function (figure) {
      var $swiperSlide = $('<div />', {
          class: 'swiper-slide'
        }),
        $figure = $('<figure />'),
        $img = $('<img />', {
          src: figure.src,
          alt: figure.alt
        }),
        $figcaption = $('<figcaption />', {
          text: figure.alt
        });
      $figure.append($img).append($figcaption);
      $swiperSlide.append($figure);
      $swiperWrapper.append($swiperSlide);
    });
    $swiperContainer.append($swiperWrapper).append($swiperPagination);
    $figureContainer.append($swiperContainer);
    $modal.modal('show');
  }).on('shown.bs.modal', function () {
    var $swiperContainer = $('.swiper-container', this);
    new Swiper($swiperContainer.get(0), {
      modules: window.swiperModule,
      slidesPerView: 'auto',
      loop: false
    });
  }).on('hidden.bs.modal', function () {
    $('.figures-container', this).empty();
  });
});